import React from 'react';
import { AdditionalModalAdminViewProps, DeclineFormKeys } from './types';
import { Button } from '@vtbhome/juicyfront';
import { Field, Form } from 'react-final-form';
import { Typography } from '@shared/ui/typography/typography';
import { Textarea } from '@shared/ui/textarea/textarea';
import { Footer, Content, StyledTypography } from './additional-modal-admin-view.styles';
import { validateForm } from '@shared/lib/validation/validate/validate';
import { maxLength } from '@shared/lib/validation/validateMaxLength/max-length';
import { Modal } from '@shared/ui/modal/modal';
import { useResetModalForm } from '@shared/lib/hooks/use-reset-modal-form/use-reset-modal-form';

export const AdditionalModalAdminView: React.FC<AdditionalModalAdminViewProps> = ({
    headerTitle,
    text,
    isShow,
    showPreloader = false,
    onClose,
    onSubmit,
}) => {
    const formRef = useResetModalForm<Record<DeclineFormKeys, string>>(isShow);

    return (
        <Form
            subscription={{}}
            onSubmit={onSubmit}
            validate={(fields) => {
                const { validateField, errors } = validateForm();
                validateField({
                    name: DeclineFormKeys.Comment,
                    message: maxLength(fields[DeclineFormKeys.Comment], 255),
                });
                return errors;
            }}
            render={(form) => {
                formRef.current = form;
                return (
                    <Modal
                        isShow={isShow}
                        size='l'
                        showLine={false}
                        header={<Typography size='h5'>{headerTitle}</Typography>}
                        footer={
                            <Footer>
                                <Button
                                    buttonType='light'
                                    preloader={showPreloader}
                                    disabled={showPreloader}
                                    onClick={onClose}>
                                    Отменить
                                </Button>
                                <Button
                                    buttonType='primary'
                                    preloader={showPreloader}
                                    disabled={showPreloader}
                                    onClick={form.handleSubmit}>
                                    Подтвердить
                                </Button>
                            </Footer>
                        }
                        onClose={onClose}>
                        <Content>
                            <StyledTypography size='body1_long' color='neutral_90' as='p'>
                                {text}
                            </StyledTypography>
                            <Field
                                name={DeclineFormKeys.Comment}
                                render={({ input, meta }) => (
                                    <Textarea
                                        label='Комментарий (необязательно)'
                                        placeholder='Введите комментарий'
                                        name={input.name}
                                        value={input.value}
                                        error={meta.touched && meta.error}
                                        onChange={input.onChange}
                                    />
                                )}
                            />
                        </Content>
                    </Modal>
                );
            }}
        />
    );
};
